import Model, { attr, hasMany } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import type ThoughtBubbleStepModel from './thought-bubble-step';
import type { TargetingRules } from '../types/thought-bubble';

export default class ThoughtBubbleFlowModel extends Model {
  @attr declare name: string;
  @attr declare description: string;
  @attr declare flowType: string;
  @attr declare app: string;
  @attr declare route: string;
  @attr declare status: string;
  @attr declare priority: number;
  @attr declare targetingRules: TargetingRules;
  @attr declare enabledDomains: string[];
  @attr declare createdAt: string;
  @attr declare updatedAt: string;

  @hasMany('thought-bubble-step', { async: false, inverse: 'flow' })
  declare steps: ThoughtBubbleStepModel[];

  [Type] = 'thought-bubble-flow' as const;
}
